module.exports = __webpack_public_path__ + "static/media/1.9734e374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/samples/1.png
// module id = 312
// module chunks = 0